import eligibility from './eligibility.png';
import deadlines from './deadlines.png';
import mail from './mail.png';
import ballotbox from './ballotbox.png';
import id from './id.png';
import pollingplace from './pollingplace.png';
import postage from './postage.png';
import signature from './signature.png';
import tracking from './tracking.png';

export default {
    eligibility,
    deadlines,
    mail,
    ballotbox,
    id,
    pollingplace,
    postage,
    signature,
    tracking,
};
